import { mainMenuNavigation } from "./main-menu-navigation.js"
import { mobileMenuClick } from "./mobile-menu.js"
import { contactForm } from "./contact-form.js"
import { slider } from "./slider-services.js"
import { feedbackOverlay } from "./contact-form-overlay.js"
import { canvas } from "./canvas.js"

mainMenuNavigation()
mobileMenuClick()
contactForm()
slider()
feedbackOverlay()
canvas()
